// extracted by mini-css-extract-plugin
export default {"root":"ImageCard-module--root--3b5da","container":"ImageCard-module--container--60e39","overlay":"ImageCard-module--overlay--d7213","content":"ImageCard-module--content--c41fa"};